module.exports = __webpack_public_path__ + "img/xiaochengxu.88339129.jpg";